/**
 * What Publish checks, whichever layout asks: what blocks it, the emails that wait for the business's email setup, and
 * how many of the steps were looked at.
 */
import type { BoardState } from "../../../shared/types";
import { useSetup } from "../../setup/SetupContext";
import type { BoardHost } from "../host";
import { WALK_STEPS } from "./useWalk";

export function usePublishFacts(state: BoardState, host: BoardHost, looked: ReadonlySet<string>) {
  const setup = useSetup();
  const blocks = host.server.publishBlocks;
  // The emails this room's follow-ups send, on for it: while email is not set up they wait for it.
  const waiting =
    setup.state && !setup.state.email
      ? state.mail.reduce((n, m) => {
          const row = m.kind === "mail" && m.on && m.automationId ? host.followUpRows.get(m.automationId) : undefined;
          return n + (row ? row.graph.nodes.filter((x) => x.type === "email").length : 0);
        }, 0)
      : 0;
  const seen = WALK_STEPS.filter((k) => looked.has(k)).length;
  const title = host.server.title || state.workingTitle;
  return { blocks, waiting, seen, title, canEdit: setup.canEdit };
}
